<div *ngIf="loaderService.loaderState$ | async" class="progress-bar-container">
    <mat-progress-bar mode="indeterminate" color="warn"></mat-progress-bar>
</div>